<template>
  <div>
    <fieldset>
      <legend class="text-blue">
        {{ $t('serviceRequest.plannedMaintenance') }}
        <Tooltip placement="top">
          <Icon type="ios-information-circle-outline" size="17" />
          <div slot="content">
            <div class="ts-text-xs">
              Details.
            </div>
          </div>
        </Tooltip>
      </legend>
      <div class="overflow-auto ts-max-h-40">
        <div class="table-ui-detail">
          <table>
            <thead>
              <tr>
                <th width="1%" class="ts-text-center">
                  {{ $t('no') }}
                </th>
                <th width="10%">
                  {{ $t('serviceRequest.serviceRequestDate') }}
                </th>
                <th width="20%">
                  {{ $t('serviceRequest.serviceRequestType') }}
                </th>
                <th class="text-center" width="10%">
                  {{ $t('serviceRequest.serviceStatus') }}
                </th>
                <th class="text-center" width="10%">
                  {{ $t('serviceRequest.feeType') }}
                </th>
                <th class="text-center" width="5%">
                  {{ $t('actions') }}
                </th>
              </tr>
            </thead>
            <tbody v-if="model.planned_maintenance">
              <tr
                v-for="(detail, index) in model.planned_maintenance"
                :key="index"
              >
                <td class="ts-whitespace-nowrap ts-text-center">
                  {{ index + 1 }}
                </td>
                <td class="ts-whitespace-nowrap">
                  <a-date-picker
                    v-model="detail.service_request_date"
                    format="DD-MM-YYYY"
                    valueFormat="DD-MM-YYYY"
                    class="ts-w-full"
                  ></a-date-picker>
                </td>
                <td class="ts-whitespace-nowrap">
                  <a-select
                    v-model="detail.service_request_type_id"
                    :options="serviceRequestTypes"
                    show-search
                    disabled
                    option-filter-prop="children"
                    :filter-option="filterOption"
                    class="ts-w-full"
                    placeholder="Select"
                  ></a-select>
                </td>
                <td class="text-center ts-whitespace-nowrap">
                  <a-select
                    v-model="detail.service_status"
                    :options="serviceStatus"
                    show-search
                    disabled
                    option-filter-prop="children"
                    :filter-option="filterOption"
                    class="ts-w-full"
                    placeholder="Select"
                  ></a-select>
                </td>
                <td class="text-center ts-whitespace-nowrap">
                  <a-select
                    v-model="detail.fee_type_id"
                    :options="feeTypes"
                    show-search
                    disabled
                    option-filter-prop="children"
                    :filter-option="filterOption"
                    class="ts-w-full"
                    placeholder="Select"
                  ></a-select>
                </td>
                <td class="text-center">
                  <Tooltip
                    placement="top"
                    :transfer="true"
                    :content="$t('remove')"
                  >
                    <a
                      href="#"
                      class="text-danger"
                      @click.prevent="removeRow(detail)"
                    >
                      <Icon type="ios-remove-circle-outline" size="20" />
                    </a>
                  </Tooltip>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'plannedMaintenance',
  props: ['value', 'validate'],
  data() {
    return {
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('serviceManagement/serviceRequest', ['formViewDatas']),
    serviceRequestTypes() {
      if (this.formViewDatas['serviceRequestTypes']) {
        return this.formViewDatas['serviceRequestTypes'].map(el => ({
          value: el.service_request_type_id,
          label: el.service_request_type,
          service_request_schedule: el.service_request_schedule
        }))
      }
      return []
    },
    feeTypes() {
      if (this.formViewDatas['feeTypes']) {
        return this.formViewDatas['feeTypes'].map(el => ({
          value: el.product_id,
          label: el.product_name_en
        }))
      }
      return []
    },
    serviceStatus() {
      return [
        {
          label: 'Pending',
          value: 0
        },
        {
          label: 'Progressing',
          value: 1
        },
        {
          label: 'Completed',
          value: 2
        },
        {
          label: 'Cancel',
          value: 3
        }
      ]
    }
  },
  methods: {
    removeRow(detail) {
      this.model.planned_maintenance.splice(
        this.model.planned_maintenance.indexOf(detail),
        1
      )
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
<style scoped>
* {
  font-family: Roboto, Khmer, Ionicons;
}
</style>
